import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_TRACKER = "/api/material_requests";

export default {
  async getMaterialRequests(params) {
    return await Api()
      .get(RESOURCE_TRACKER, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createMaterialRequest(params) {
    return Api()
      .post(RESOURCE_TRACKER, params)
      .catch((err) => errorHandler(err, null));
  },
  async updateMaterialRequest(id, params) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async getMaterialRequest(id, params) {
    return Api()
      .get(`${RESOURCE_TRACKER}/${id}`, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async rejectMaterialRequest(id, params) {
    return Api()
      .post(`${RESOURCE_TRACKER}/${id}/reject`, params)
      .catch((err) => errorHandler(err, null));
  },
  async approveMaterialRequest(id, params) {
    return Api()
      .post(`${RESOURCE_TRACKER}/${id}/approve`, params)
      .catch((err) => errorHandler(err, null));
  },
  async fulfillMaterialRequest(id, params) {
    return Api()
      .post(`${RESOURCE_TRACKER}/${id}/fulfill`, params)
      .catch((err) => errorHandler(err, null));
  },
};
